module.exports = __webpack_public_path__ + "img/3s.30359835.png";